<div class="wrapper d-flex align-items-stretch">
  <ozm-sidebar></ozm-sidebar>

  <div id="content" class="p-4 p-md-5">
    <div class="tp-wr">
      <ozm-header></ozm-header>
      
      <div class="container-fluid category-page">
        <!-- Modern Page Header with Breadcrumb -->
        <div class="page-header-section">
          <div class="breadcrumb-nav">
            <a [routerLink]="['/']" class="breadcrumb-item">
              <i class="fas fa-home"></i> Home
            </a>
            <span class="breadcrumb-separator">/</span>
            <a [routerLink]="['/category']" class="breadcrumb-item">Categories</a>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item active">{{ category }}</span>
            <span class="breadcrumb-separator" *ngIf="selectedSubcategory">/</span>
            <span class="breadcrumb-item active" *ngIf="selectedSubcategory">{{ selectedSubcategory }}</span>
          </div>
          
          <div class="page-title-section">
            <div class="title-content">
              <h1 class="page-title">
                <span class="category-icon-wrapper">
                  <i class="fas fa-layer-group"></i>
                </span>
                {{ category || 'All Categories' }}
              </h1>
              <p class="page-subtitle" *ngIf="!selectedSubcategory">
                Select apps from the <strong>{{ category }}</strong> category to add to your favorites
              </p>
              <p class="page-subtitle" *ngIf="selectedSubcategory">
                Choose your favorite app for <strong>{{ selectedSubcategory }}</strong>
              </p>
            </div>
            
            <!-- Active Filter Badge -->
            <div class="active-filter-badge" *ngIf="selectedSubcategory">
              <div class="filter-content">
                <i class="fas fa-filter"></i>
                <span>Filtering by: <strong>{{ selectedSubcategory }}</strong></span>
                <button class="clear-filter-btn" (click)="clearSubcategoryFilter()" title="Clear filter">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <!-- Main Content Area -->
          <div class="col-lg-8 mt-2">
            <!-- Stats Bar -->
            <div class="stats-bar" *ngIf="!loading && appsInSelectedCategory.length > 0">
              <div class="stat-item">
                <i class="fas fa-apps"></i>
                <span><strong>{{ appsInSelectedCategory.length }}</strong> Apps Available</span>
              </div>
              <div class="stat-item">
                <i class="fas fa-check-circle"></i>
                <span><strong>{{ getSelectedAppIds().length }}</strong> Selected</span>
              </div>
              <div class="stat-item">
                <i class="fas fa-star"></i>
                <span><strong>{{ userFavoriteApps.length }}</strong> Favorites</span>
              </div>
            </div>
            
            <!-- Subcategory Chips -->
            <div class="subcategory-section" *ngIf="category && subCategories.length > 0">
              <h3 class="section-title">
                <i class="fas fa-tags"></i> Subcategories in {{ category }}
              </h3>
              
              <div class="subcategory-chips-container">
                <!-- All Subcategories Chip -->
                <button class="subcategory-chip" 
                        [class.active]="!selectedSubcategory"
                        (click)="clearSubcategoryFilter()">
                  <span class="chip-icon"><i class="fas fa-th"></i></span>
                  <span class="chip-label">All</span>
                  <span class="chip-count">{{ allAppsInCategory.length }}</span>
                </button>
                
                <!-- Individual Subcategory Chips -->
                <button *ngFor="let subcat of subCategories" 
                        class="subcategory-chip"
                        [class.active]="subcat.name === selectedSubcategory"
                        (click)="selectSubcategory(subcat)">
                  <span class="chip-icon"><i class="fas fa-folder"></i></span>
                  <span class="chip-label">{{ subcat.name }}</span>
                  <span class="chip-count">{{ getAppCountForSubcategory(subcat.name) }}</span>
                </button>
              </div>
              
              <div class="loading-subcategories" *ngIf="subcategoriesLoading">
                <i class="fas fa-spinner fa-spin"></i> Loading subcategories...
              </div>
            </div>
            
            <!-- Apps Grid with Modern Cards -->
            <div class="apps-section" *ngIf="appsInSelectedCategory.length > 0">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="fas fa-mobile-alt"></i> Available Apps
                  <span *ngIf="selectedSubcategory"> in {{ selectedSubcategory }}</span>
                </h3>
                <div class="header-actions">
                  <button class="btn-open-all" 
                          (click)="openAllApps()"
                          title="Open all apps in new tabs">
                    <i class="fas fa-external-link-alt"></i> Open All
                  </button>
                  <div class="view-toggle">
                    <button class="view-btn active" title="Grid view">
                      <i class="fas fa-th"></i>
                    </button>
                    <button class="view-btn" title="List view">
                      <i class="fas fa-list"></i>
                    </button>
                  </div>
                </div>
              </div>
              
              <div class="modern-apps-grid">
                <div class="modern-app-card" 
                     *ngFor="let app of appsInSelectedCategory"
                     [class.selected]="isAppSelected(app.appliId)"
                     [class.is-favorite]="app.isFavorite"
                     (click)="!app.isFavorite && toggleAppSelection(app)">
                  
                  <!-- Selection Indicator -->
                  <div class="card-selection-indicator" *ngIf="isAppSelected(app.appliId)">
                    <i class="fas fa-check-circle"></i>
                  </div>
                  
                  <!-- Favorite Badge -->
                  <div class="card-favorite-badge" *ngIf="app.isFavorite">
                    <i class="fas fa-star"></i> Favorite
                  </div>
                  
                  <!-- Card Content -->
                  <div class="card-image-wrapper">
                    <img [src]="getAppIcon(app)" 
                         [alt]="app.name"
                         class="card-app-image"
                         (error)="handleImageError($event)">
                    
                    <!-- Checkbox Overlay -->
                    <div class="card-checkbox" *ngIf="!app.isFavorite">
                      <input type="checkbox" 
                             [id]="'app-check-' + app.appliId"
                             [checked]="isAppSelected(app.appliId)"
                             (click)="$event.stopPropagation()"
                             (change)="toggleAppSelection(app)">
                      <label [for]="'app-check-' + app.appliId"></label>
                    </div>
                  </div>
                  
                  <div class="card-body">
                    <h4 class="card-app-name" [title]="app.name">{{ app.name }}</h4>
                    <p class="card-app-category">
                      <i class="fas fa-tag"></i> {{ getDisplaySubcategoryName(app) }}
                    </p>
                  </div>
                  
                  <!-- Card Actions -->
                  <div class="card-actions">
                    <button class="card-action-btn btn-primary" 
                            *ngIf="!app.isFavorite && !isAppSelected(app.appliId)"
                            (click)="$event.stopPropagation(); toggleAppSelection(app)">
                      <i class="fas fa-plus"></i> Select
                    </button>
                    <button class="card-action-btn btn-success" 
                            *ngIf="isAppSelected(app.appliId)"
                            (click)="$event.stopPropagation(); toggleAppSelection(app)">
                      <i class="fas fa-check"></i> Selected
                    </button>
                    <button class="card-action-btn btn-danger" 
                            *ngIf="app.isFavorite"
                            (click)="$event.stopPropagation(); removeFromFavorites(app, $event)">
                      <i class="fas fa-trash"></i> Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Enhanced Empty State -->
            <div class="enhanced-no-apps" *ngIf="category && appsInSelectedCategory.length === 0 && !loading">
              <div class="empty-state-card">
                <div class="empty-state-icon">
                  <i class="fas fa-search"></i>
                </div>
                <h3 class="empty-state-title">No Apps Found</h3>
                <p class="empty-state-message" *ngIf="selectedSubcategory">
                  No apps available for <strong>{{ selectedSubcategory }}</strong> in {{ category }}
                </p>
                <p class="empty-state-message" *ngIf="!selectedSubcategory">
                  No apps available in <strong>{{ category }}</strong>
                </p>
                
                <!-- Debug Information -->
                <div class="debug-info-panel" *ngIf="allAppsInCategory.length > 0">
                  <div class="debug-header">
                    <i class="fas fa-exclamation-triangle"></i>
                    <strong>Data Mismatch Detected</strong>
                  </div>
                  <div class="debug-content">
                    <p><strong>Total apps in {{ category }}:</strong> {{ allAppsInCategory.length }}</p>
                    <p><strong>Looking for subcategory:</strong> "{{ selectedSubcategory }}"</p>
                    <div class="available-subcategories">
                      <strong>Available subcategories:</strong>
                      <div class="subcategory-tags">
                        <span class="subcategory-tag" *ngFor="let subCat of getUniqueSubCategories()">
                          {{ subCat }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <button class="btn-clear-filter" 
                        (click)="clearSubcategoryFilter()" 
                        *ngIf="selectedSubcategory">
                  <i class="fas fa-times"></i> Clear Filter & Show All Apps
                </button>
              </div>
            </div>
            
            <!-- Loading State with Skeleton -->
            <div class="loading-skeleton" *ngIf="loading">
              <div class="skeleton-header"></div>
              <div class="skeleton-grid">
                <div class="skeleton-card" *ngFor="let item of [1,2,3,4,5,6]">
                  <div class="skeleton-image"></div>
                  <div class="skeleton-text"></div>
                  <div class="skeleton-text short"></div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Enhanced Right Sidebar -->
          <div class="col-lg-4 mt-2">
            <!-- Selected Apps Panel with Modern Design -->
            <div class="modern-selected-panel">
              <div class="panel-sticky-wrapper">
                <div class="panel-header-modern">
                  <div class="panel-title-group">
                    <i class="fas fa-check-double"></i>
                    <h3>Selected Apps</h3>
                  </div>
                  <div class="selection-badge">
                    {{ getSelectedAppIds().length }}
                  </div>
                </div>
                
                <div class="panel-body-modern">
                  <!-- Selected Apps List -->
                  <div class="modern-selected-list" *ngIf="getSelectedAppIds().length > 0">
                    <div class="modern-selected-item" *ngFor="let appId of getSelectedAppIds()">
                      <div class="selected-item-content" *ngIf="getAppById(appId)">
                        <img [src]="getAppIcon(getAppById(appId))" 
                             [alt]="getAppById(appId)?.name" 
                             class="selected-item-icon"
                             (error)="handleImageError($event)">
                        <div class="selected-item-info">
                          <span class="selected-item-name">{{ getAppById(appId)?.name }}</span>
                          <small class="selected-item-cat">{{ getDisplaySubcategoryName(getAppById(appId)) }}</small>
                        </div>
                      </div>
                      <button class="btn-remove-selected" 
                              (click)="toggleAppSelection(getAppById(appId))" 
                              *ngIf="getAppById(appId)"
                              title="Remove from selection">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    
                    <!-- Add to Favorites Action -->
                    <div class="add-favorites-action">
                      <button class="btn-add-to-favorites" 
                              (click)="addSelectedAppsToFavorites()"
                              [disabled]="favoritesLoading"
                              [class.loading]="favoritesLoading">
                        <i class="fas fa-heart" *ngIf="!favoritesLoading"></i>
                        <i class="fas fa-spinner fa-spin" *ngIf="favoritesLoading"></i>
                        <span *ngIf="!favoritesLoading">
                          {{ selectedSubcategory ? 'Set as Favorite' : 'Add to Favorites' }}
                        </span>
                        <span *ngIf="favoritesLoading">Adding...</span>
                      </button>
                      
                      <small class="helper-text" *ngIf="selectedSubcategory && getSelectedAppIds().length > 1">
                        <i class="fas fa-info-circle"></i> Select only one app for {{ selectedSubcategory }}
                      </small>
                    </div>
                  </div>
                  
                  <!-- Empty State for Selection Panel -->
                  <div class="selection-empty-state" *ngIf="getSelectedAppIds().length === 0">
                    <div class="empty-illustration">
                      <i class="fas fa-mouse-pointer"></i>
                    </div>
                    <p class="empty-text">Select apps to add them to your favorites</p>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Favorite Apps Preview Panel -->
            <div class="modern-favorites-preview">
              <div class="panel-header-modern">
                <div class="panel-title-group">
                  <i class="fas fa-star"></i>
                  <h3>Your Favorites</h3>
                </div>
                <a [routerLink]="['/my-favorites']" class="view-all-link">
                  View All <i class="fas fa-arrow-right"></i>
                </a>
              </div>
              
              <div class="panel-body-modern">
                <!-- Loading State -->
                <div class="favorites-loading" *ngIf="loading">
                  <i class="fas fa-spinner fa-spin"></i> Loading favorites...
                </div>
                
                <!-- Favorites List -->
                <div class="modern-favorites-list" *ngIf="!loading && userFavoriteApps.length > 0">
                  <div class="favorite-preview-item" *ngFor="let app of userFavoriteApps.slice(0, 5)">
                    <img [src]="getAppIcon(app)" 
                         [alt]="app.name" 
                         class="favorite-preview-icon"
                         (error)="handleImageError($event)">
                    <div class="favorite-preview-info">
                      <span class="favorite-preview-name">{{ app.name }}</span>
                      <small class="favorite-preview-cat">{{ app.subCategory }}</small>
                    </div>
                    <button class="btn-remove-favorite" 
                            (click)="removeFromFavoritesList(app)"
                            title="Remove from favorites">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  
                  <div class="favorites-view-more" *ngIf="userFavoriteApps.length > 5">
                    <a [routerLink]="['/my-favorites']" class="link-view-more">
                      +{{ userFavoriteApps.length - 5 }} more favorites →
                    </a>
                  </div>
                </div>
                
                <!-- Empty State for Favorites -->
                <div class="favorites-empty-state" *ngIf="!loading && userFavoriteApps.length === 0">
                  <div class="empty-illustration">
                    <i class="fas fa-heart-broken"></i>
                  </div>
                  <p class="empty-text">No favorites yet</p>
                  <a [routerLink]="['/my-favorites']" class="btn-goto-favorites">
                    <i class="fas fa-heart"></i> Go to Favorites
                  </a>
                </div>
              </div>
            </div>
            
            <!-- Quick Tips Panel -->
            <div class="quick-tips-panel">
              <div class="tips-header">
                <i class="fas fa-lightbulb"></i> Quick Tips
              </div>
              <div class="tips-body">
                <div class="tip-item">
                  <i class="fas fa-check-circle"></i>
                  <span>Click on app cards to select them</span>
                </div>
                <div class="tip-item">
                  <i class="fas fa-filter"></i>
                  <span>Use subcategory chips to filter apps</span>
                </div>
                <div class="tip-item">
                  <i class="fas fa-star"></i>
                  <span>One favorite app per subcategory</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
